import * as React from "react";
import { memo } from "react";
import styled, { ThemeContext } from "styled-components";
import { themeGet } from "@styled-system/theme-get";
import { Text } from "pcln-design-system";
const IconWrapper = /*#__PURE__*/styled(Text).withConfig({
  displayName: "HotelsOutline__IconWrapper",
  componentId: "sc-140gewh-0"
})(["display:inline-block;"]);
function BaseComponent({
  title,
  titleId,
  ...props
}) {
  const themeContext = React.useContext(ThemeContext);
  const themeProps = {
    theme: themeContext
  };
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    focusable: false,
    "aria-hidden": true,
    role: "img",
    "aria-labelledby": titleId,
    ...props
  }, title ? React.createElement("title", {
    id: titleId
  }, title) : null, React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("path", {
    fill: themeGet("palette.primary.light")(themeProps),
    d: "M5 21V2h14v19z"
  }), React.createElement("path", {
    fill: themeGet("palette.primary.base")(themeProps),
    d: "M21 1a.5.5 0 0 1 .09.992L21 2h-1v11.39a1.91 1.91 0 0 1 3.126.205c.323.536.356 1.183.118 1.734l-.05.103.12.116c.475.498.729 1.178.68 1.88l-.018.175a2.48 2.48 0 0 1-1.85 2.056l-.123.015-.028-.001V21h.525a.5.5 0 0 1 .09.992L22.5 22h-21a.5.5 0 0 1-.09-.992L1.5 21h.525v-1.327H2l-.123-.015a2.483 2.483 0 0 1-1.198-4.115l.112-.111-.038-.074a1.9 1.9 0 0 1-.164-.623l-.006-.164a1.904 1.904 0 0 1 1.4-1.828l.156-.036a1.91 1.91 0 0 1 1.863.707L4 2H3a.5.5 0 0 1-.09-.992L3 1zm-2 1H5v19h3v-4.5a.5.5 0 0 1 .41-.492L8.5 16h7a.5.5 0 0 1 .492.41l.008.09V21h3zM4.001 19.243a2.5 2.5 0 0 1-.876.416l-.122.015-.028-.001V21H4Zm16-.003L20 21h1.025v-1.327H21l-.123-.015A2.5 2.5 0 0 1 20 19.24M8.5 12a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-8-4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-8-4a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z"
  }), React.createElement("path", {
    fill: themeGet("palette.background.lightest")(themeProps),
    d: "M11.5 17v4H9v-4zm3.5 0v4h-2.5v-4zm7.27-2.888c.209.346.16.79-.118 1.084a.5.5 0 0 0-.128.249l-.009.105a.5.5 0 0 0 .249.433c.52.302.805.887.721 1.48l-.025.135a1.48 1.48 0 0 1-.947 1.051l-.08.024h-.863l-.079-.024a1.485 1.485 0 0 1-.26-2.68.5.5 0 0 0 .102-.78.87.87 0 0 1-.25-.614.91.91 0 0 1 1.687-.463m-19 0c.209.346.16.79-.118 1.084a.5.5 0 0 0-.128.249l-.009.105a.5.5 0 0 0 .249.433c.52.302.805.887.721 1.48l-.025.135a1.48 1.48 0 0 1-.947 1.051l-.08.024H2.07l-.079-.024a1.485 1.485 0 0 1-.26-2.68.5.5 0 0 0 .102-.78.87.87 0 0 1-.25-.614.91.91 0 0 1 1.687-.463"
  })));
}
const HotelsOutline = props => React.createElement(IconWrapper, {
  fontSize: props.size,
  lineHeight: props.size,
  verticalAlign: "middle",
  className: props.className
}, React.createElement(BaseComponent, null));
/** @public */
const Memo = memo(HotelsOutline);
export default Memo;